import { Component, OnInit, Inject } from '@angular/core';
import { FileSystemDirectoryEntry, FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/app.service';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Dimensions, ImageTransform } from '../image-cropper/interfaces';
import { blob } from 'stream/consumers';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile, toBlobURL } from '@ffmpeg/util';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss']
})
export class UploadImageComponent implements OnInit {
  store_id: any;
  images: any[] = [];
  fileToUpload: File = null;
  public files: NgxFileDropEntry[] = [];
  searchText: string;
  resource_type: any = null;

  resource_type_id: any = 0;
  visibleloader: boolean = true;

  viewMode: 'grid' | 'list' = 'grid'; // Added viewMode
  selectedTabIndex: number = 0; // Added selectedTabIndex
  page_first_result: number = 0;
  result_per_page: number = 40;
  public counts = [40, 80, 120, 160, 200, 240];
  public count: any = this.counts[0];
  rowCount: any = 0;
  page: any = 1;
  medialoader: boolean;
  Height: any = 0;
  Width: any = 0;
  language: any[];
  language_id: any = 0;

  // Crop Image
  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppedImage_url: any = '';

  canvasRotation = 0;
  rotation?: number;
  translateH = 0;
  translateV = 0;
  scale = 1;
  aspectRatio = 4 / 3;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {
    translateUnit: 'px'
  };
  imageURL?: string;
  loading = false;
  allowMoveImage = false;
  hidden = false;
  filesize: string;
  originalFileName: string = '';
  originalFile: File | null = null;

  uploadFile: any;

  resource_types: any[] = [];
  ffmpeg = new FFmpeg();

  constructor(public dialogRef: MatDialogRef<UploadImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, public appService: AppService, public snackBar: MatSnackBar, public http: HttpClient, private sanitizer: DomSanitizer) {
    this.appService.Data.selectedIMG = [];
    this.resource_type_id = +data.resource_type_id || 0;
    this.store_id = data.store_id;
    this.resource_types = Array.isArray(data.resource_types) ? data.resource_types : [];

    // Configure FFmpeg to use worker from assets
    this.ffmpeg = new FFmpeg();
    this.ffmpeg.on('log', ({ message }) => {
      console.log('[FFmpeg]', message);
    });

    // Load resource types from DB 
    this.getAllLanguage();
    this.getAllResourcetypes();
    this.loadMedias();

  }

  async loadFFmpeg() {
    try {
      // Option 1: Load from local assets (offline)
      const baseURL = '/assets/ffmpeg';
      await this.ffmpeg.load({
        coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, 'text/javascript'),
        wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, 'application/wasm'),
      });

      // Option 2: Load from CDN (online) - uncomment to use
      // const baseURL = 'https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd';
      // await this.ffmpeg.load({
      //   coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, 'text/javascript'),
      //   wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, 'application/wasm'),
      // });

      console.log('FFmpeg loaded successfully');
    } catch (error) {
      console.error('Failed to load FFmpeg:', error);
      throw error;
    }
  }
  // File Crop methods
  fileChangeEvent(event: any): void {
    this.loading = true;
    this.imageChangedEvent = event;

    const file: File = event.target.files[0];
    this.originalFile = file;
    this.originalFileName = file.name;
  }

  async imageCropped(event: ImageCroppedEvent) {
    // Display the preview immediately (static)
    this.croppedImage_url = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl || event.base64 || '');
    this.croppedImage = event;

    // For development: Process all images including GIFs as static images
    // FFmpeg has Worker security issues in dev mode (localhost)
    // In production, this would use FFmpeg for animated GIFs

    if (this.originalFile?.type === 'image/gif') { // Disabled for dev mode
      // Only use FFmpeg in production builds where Worker security is not an issue
      await this.processAnimatedGif(event);
    } else {
      // Standard static WebP conversion (works for all images including GIFs)
      this.processStaticImage(event);
    }

  }

  async processAnimatedGif(event: ImageCroppedEvent) {
    this.loading = true;
    try {
      if (!this.ffmpeg.loaded) {
        await this.loadFFmpeg();
      }

      const cropperPos = event.cropperPosition;
      const x = Math.round(cropperPos.x1);
      const y = Math.round(cropperPos.y1);
      const width = Math.round(cropperPos.x2 - cropperPos.x1);
      const height = Math.round(cropperPos.y2 - cropperPos.y1);

      const inputName = 'input.gif';
      const outputName = 'output.webp';

      // Write original file to FFmpeg memory
      await this.ffmpeg.writeFile(inputName, await fetchFile(this.originalFile!));

      // FFmpeg command to crop AND convert to animated WebP
      // filter: crop=w:h:x:y
      await this.ffmpeg.exec([
        '-i', inputName,
        '-vf', `crop=${width}:${height}:${x}:${y}`,
        '-loop', '0',
        '-lossless', '0',
        '-compression_level', '4',
        outputName
      ]);

      const data = await this.ffmpeg.readFile(outputName);
      // FFmpeg returns FileData which can be Uint8Array, convert for blob
      // @ts-ignore - FFmpeg type compatibility issue, works correctly at runtime
      const webpBlob = new Blob([data], { type: 'image/webp' });

      this.finalizeFile(webpBlob);
    } catch (error) {
      console.error('Error processing animated GIF:', error);
      this.snackBar.open('Failed to process animated GIF', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
      // Fallback to static image processing
      this.processStaticImage(event);
    } finally {
      this.loading = false;
    }
  }

  processStaticImage(event: ImageCroppedEvent) {
    if (event.blob) {
      this.finalizeFile(event.blob);
    }
  }

  finalizeFile(blob: Blob) {
    const fileName = this.originalFileName?.split('.')[0] + '.webp' || 'image.webp';
    this.uploadFile = new File([blob], fileName, { type: 'image/webp' });
    this.filesize = (blob.size / 1024).toFixed(2);
    console.log('Final WebP File Ready:', this.uploadFile);
  }

  imageLoaded() {
    this.showCropper = true;
    console.log('Image loaded');
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
    this.loading = false;
  }

  loadImageFailed() {
    console.error('Load image failed');
  }
  calculateAspectRatio(width: number, height: number): number {
    return (+width > 0 && +height > 0) ? (+width / +height) : (4 / 3);
  }

  uploadCroppedFiles() {
    // console.log(this.croppedImage);
    // const fileExtension = this.originalFileName.split('.').pop();
    // // Convert the blob to a File
    // const file = new File([this.croppedImage.blob], this.originalFileName, { type: this.croppedImage.blob.type });

    // this.fileUpload(file);
    if (this.resource_type_id == 0) {
      this.snackBar.open('Please Select Resource Type!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
      return;
    }

    if (this.uploadFile) {
      console.log('Uploading WebP file:', this.uploadFile);
      this.fileUpload(this.uploadFile);
    } else {
      console.error('No WebP file available for upload');
    }

  }

  // Files Crop Section End
  getAllLanguage() {
    this.appService.getAllLanguage().subscribe(data => {
      this.language = Array.isArray(data) ? data : [];
      this.language_id = this.language.length > 0 ? this.language[0].language_id : 0;
    }, error => {
      //  Admin portal should logout when token expired
      if (error.error.status) {
        this.appService.signOut();
      }
    });
  }

  getLanguageID(language_id) {
    this.language_id = language_id;
  }

  loadMedias() {
    this.visibleloader = true;
    this.images = [];
    this.rowCount = 0;
    this.searchText = this.searchText ? this.searchText : '';
    this.appService.getAllImages(this.resource_type_id, this.page_first_result, this.result_per_page, this.searchText).subscribe(data => {
      this.images = data;

      console.log(this.images);
      this.rowCount = this.images.length > 0 ? this.images[0].row_count : 0;
      this.visibleloader = false;
    }, error => {
      //  Admin portal should logout when token expired
      if (error.error.status) {
        this.appService.signOut();
      }
    });
  }
  getImages() {
    this.loadMedias();

  }
  getAllResourcetypes() {
    if (this.resource_types.length > 0 && this.resource_type_id != 0) {
      this.resource_type = this.resource_types.filter(item => item.resource_type_id == this.resource_type_id)[0];
      if (this.resource_type) {
        this.Height = this.resource_type.Height;
        this.Width = this.resource_type.Width;
        this.aspectRatio = this.calculateAspectRatio(this.Width, this.Height);
      }
    } else if (this.resource_types.length == 0) {
      this.appService.getResourceTypes().subscribe(data => {
        if (Array.isArray(data) && data.length > 0) {
          // Set Store logo image details to resource_type variable
          // To show image heigh & Width in upload window
          this.resource_types = data;
          if (this.resource_type_id != 0) {
            this.resource_type = data.filter(item => item.resource_type_id == this.resource_type_id)[0];
            if (this.resource_type) {
              this.Height = this.resource_type.Height;
              this.Width = this.resource_type.Width;
              this.aspectRatio = this.calculateAspectRatio(this.Width, this.Height);
            }
          }
        }

      }, error => {
        //  Admin portal should logout when token expired
        if (error.error.status) {
          this.appService.signOut();
        }
      });
    }
  }

  onResourceTypeChange(resource_type_id) {
    this.resource_type_id = resource_type_id;
    this.resource_type = this.resource_types.filter(item => item.resource_type_id == this.resource_type_id)[0];
    if (this.resource_type) {
      this.Height = this.resource_type.Height;
      this.Width = this.resource_type.Width;
      this.aspectRatio = this.calculateAspectRatio(this.Width, this.Height);
      this.loadMedias();
    }
  }

  fileUpload(files: File) {
    this.medialoader = true;
    let formData = new FormData();
    formData.append('file', files);
    formData.append('User_id', this.appService.Data.user_id);
    formData.append('resource_type', this.resource_type_id);
    formData.append('store_id', this.store_id);
    formData.append('company_id', "1");
    formData.append('language_id', this.language_id);


    this.http.post(this.appService.ecomUrl + '/media', formData, { headers: this.appService.headers }).subscribe(
      (data: any) => {

        if (data == 1) {
          this.snackBar.open('File Not Found!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
        }
        if (data == 2) {
          this.snackBar.open('Invalid File!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
        }
        if (data == 3) {
          this.snackBar.open('Something wrong!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
        }
        if (data == 4) {
          this.snackBar.open('Height and Width must not exceed 4096px.!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
        }
        if (data == 5) {
          this.snackBar.open('file size must not exceed 2 Mb.!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
        }
        if (data == 6) {
          this.snackBar.open('Invalid File Type!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
        }

        // Reset upload state
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.croppedImage_url = '';
        this.uploadFile = null;
        this.showCropper = false;

        // Switch to library tab
        this.selectedTabIndex = 1;

        this.loadMedias();

        this.medialoader = false;
      }, error => {
        //  Admin portal should logout when token expired
        if (error.error.status) {
          this.appService.signOut();
        }
      });


  }

  handleFileInput(event: any) {
    this.fileChangeEvent(event);

  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    // this.dataSource.filter = filterValue;
  }
  isSelected(image: any): boolean {
    return this.appService.Data.selectedIMG.some(item => item.resource_id === image.resource_id);
  }

  addToSelectedIMG(image: any, isChecked: boolean) {
    if (isChecked) {
      if (!this.isSelected(image)) {
        this.appService.Data.selectedIMG.push(image);
      }
    } else {
      const index = this.appService.Data.selectedIMG.findIndex(item => item.resource_id === image.resource_id);
      if (index !== -1) {
        this.appService.Data.selectedIMG.splice(index, 1);
      }
    }
  }
  deleteResource(resourceid) {
    // this.appService.deleteImage(resourceid).subscribe(data => {

    //   if (data.resource_id > 0) {
    //     this.loadMedias();
    //     this.snackBar.open('Deleted Image successfully!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });

    //     this.appService.Data.selectedIMG = [];

    //   }
    // }, error => {
    //   //  Admin portal should logout when token expired
    //   if (error.error.status) {
    //     this.appService.signOut();
    //   }
    // });

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "400px",
      data: {
        title: "Confirm Action",
        message: "Are you sure you want to delete this image?",
        buttonName1: "No",
        buttonName2: "Yes",
      },
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.appService.deleteImage(resourceid).subscribe(data => {
          if (data.resource_id > 0) {
            this.loadMedias();
            this.snackBar.open('Deleted Image successfully!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
            this.appService.Data.selectedIMG = [];
          }
        }, error => {
          // Admin portal should logout when token expired
          if (error.error.status) {
            this.appService.signOut();
          }
        });
      }
    });
  }
  closeDialog(): void {
    this.dialogRef.close(this.appService.Data.selectedIMG);
  }
  addImage() {
    this.dialogRef.close(this.appService.Data.selectedIMG);
  }

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {

      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {

          // Here you can access the real file
          // console.log(droppedFile.relativePath, file);

          if (file.type.match(/image\/*/) == null) {
            this.snackBar.open('Only images are supported', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
            return;
          }

          // Mock the event object expected by fileChangeEvent
          const event = {
            target: {
              files: [file]
            }
          };
          this.fileChangeEvent(event);

        });

        // Only process the first file
        break;
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(droppedFile.relativePath, fileEntry);
      }
    }
  }

  public fileOver(event) {
    console.log(event);
  }

  public fileLeave(event) {
    console.log(event);
  }

  ngOnInit() {
  }

  public changeCount(count) {
    this.count = +count; // Ensure number
    this.page = 1;
    this.page_first_result = 0;
    this.result_per_page = this.count;
    this.loadMedias();
  }

  public onPageChanged(event) {
    // Robust parsing for manual input
    let newPage = +event;

    // Validate Bounds
    const maxPage = Math.ceil(this.rowCount / this.count) || 1;
    if (newPage < 1) newPage = 1;
    if (newPage > maxPage) newPage = maxPage;

    this.page = newPage;
    this.page_first_result = (this.page - 1) * this.count;
    this.result_per_page = this.count;
    this.loadMedias();
  }

}
